import React from 'react';
import PropTypes from 'prop-types';

const TabNonSwipeableArea = ({ onTouchStart, onTouchEnd, children }) => (
  <div
    className="ws-ui-tab-non-swipeable-area"
    onTouchStartCapture={onTouchStart}
    onTouchEndCapture={onTouchEnd}
  >
    {children}
  </div>
);

TabNonSwipeableArea.propTypes = {
  children: PropTypes.node.isRequired,
  onTouchStart: PropTypes.func.isRequired,
  onTouchEnd: PropTypes.func.isRequired,
};

export default TabNonSwipeableArea;
